import { render, staticRenderFns } from "./region-filter.vue?vue&type=template&id=42c9dae7&lang=html&"
import script from "./region-filter.vue?vue&type=script&lang=js&"
export * from "./region-filter.vue?vue&type=script&lang=js&"
import style0 from "./region-filter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports